import { create } from "zustand";

interface IFiltersState {
  images: string[];
  setImages: (images: string[]) => void;
  reset: () => void;
}

const usePackagesStore = create<IFiltersState>()(
  (set): IFiltersState => ({
    images: [],
    reset: (): void => {
      set({ images: [] });
    },
    setImages: (images: string[]): void => {
      set({ images });
    },
  }),
);

export { usePackagesStore };
